module.exports = __webpack_public_path__ + "static/media/about-creating-account-1056.93c06bba.jpg";